<template>
  <v-content class="purchase">
    <div class="pa-3" v-if="data">
      <div class="text-center">
        <v-row>
          <v-col cols="12" class="pa-3 pr-0">
            <p class="mb-2 bold">{{data.ShopName}}</p>
            <p class="overline">ご購入日：{{getDateFormat(data.TransactionDate)}}</p>
            <p class="overline">レシートNo：{{data.ReferenceSlipNo}}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="grid-title pa-3 pr-0 text-left">
            <div>商品名</div>
          </v-col>
          <v-col cols="2" class="grid-title pa-3 pr-0 text-right">
            <div>数量</div>
          </v-col>
          <v-col cols="4" class="grid-title pa-3 text-right">
            <div>金額</div>
          </v-col>
        </v-row>
        <div v-for="(item,index) in data.items" :key="index">
          <v-row>
            <v-col cols="6" class="pa-3 pr-0 pb-0 text-left">
              <div class="overline">{{item.ProductName}}</div>
            </v-col>
            <v-col cols="2" class="pa-3 pr-0 pb-0 text-right">
              <div :class="{'red--text': item.SalesNum<0 }" class="overline">{{item.SalesNum}}</div>
            </v-col>
            <v-col cols="4" class="pa-3 pb-0 text-right">
              <div :class="{'red--text': item.AmountTotalInTax<0 }" class="overline">{{Number(item.AmountTotalInTax).toLocaleString()}}円</div>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col cols="12" class="pa-3 pr-0">
            <v-divider class="mt-5"></v-divider>
          </v-col>
        </v-row>
        <v-row class="flex-nowrap" no-gutters align="center">
          <v-col cols="12" class="pa-3 pr-0">
            <p :class="{'red--text': data.TotalSaleNum<0 }" class="mb-2 boldnum text-right">合計数量：{{ data.TotalSaleNum }}</p>
            <p :class="{'red--text': data.AmountTotalInTax<0 }" class="mb-2 bold text-right">{{Number(data.AmountTotalInTax).toLocaleString()}}円(税込)</p>
            <p :class="{'red--text': data.Point<0 }" class="overline mb-2 text-right">(ポイント付与：{{data.Point}}P)</p>
          </v-col>
        </v-row>
        <v-btn rounded class="caption font-weight-black" @click.stop="$router.go(-1)">閉じる</v-btn>
      </div>
    </div>
  </v-content>
</template>

<script>
import moment from "moment"
export default {
  data: () => ({
    init: [],
    data: null,
    loading: false,
  }),
  async created () {
    this.init = this.storageGet('*')
    const $ = el => document.querySelector(el);
    $(':root').style.setProperty('--main_color', this.init.color_code);
    this.loading = true
    try {
      // 外部購買履歴(詳細)取得API
      let req = {params: {
        'shop_id': this.init.sid,
        'transaction_number': this.getUrlGetParam('transaction_number'),
      }}

      let res = await this.apiCall('/purchase-external/ldx-detail', req);
      if (!res){
        this.loading = false
        return false;
      }
      this.$set(this, 'data', res);
      this.loading = false
    }catch (e) {
      this.loading = false
      this.callDialog('接続エラー', '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください', 3);
    }
  },
  methods: {
    getDateFormat: function(item) {
      return moment(item).format('YYYY年M月D日')
    }
  },
}
</script>

<style scoped>
.v-application .overline {
  word-break: break-all !important;
  line-height: 1rem;
  margin-bottom: 0px
}
.v-application .boldnum {
  font-weight: bold;
  font-size: 12px;
}
.v-application .bold {
  font-weight: bold;
}
.grid-title >>> div{
  border-bottom: var(--main_color) solid;
}
</style>
<style>
.v-application--wrap {
  min-height: 100vh;
  min-height: -webkit-fill-available;
}
</style>
